import * as React from "react";
import moment from "moment";
import {
    allocationFieldForm,
    allocationMapper,
    calculateGrowthRate,
    distributionLoanRate,
    getAllocationPayloadForAdmin,
    isALGCarrier,
    stressAllocationForALZ,
    stressAllocationsData,
} from "../utils/utils";
import {useActions} from "../../../../actions";
import * as Actions from "../../../../actions/estimation";

import {getCarrierCode, isDebug} from "../../../../utils/commonUtils";
import * as EstimatorActions from "../../../../actions/estimator";
import {useSelector} from "react-redux";
import {RootState} from "../../../../reducers";
import * as CActions from "../../../../actions/client";
import * as clientActions from "../../../../actions/client";
import {useCheckAtlantic} from "../../../../hooks/useAuth";
import {servicingMessage, servicingMessageV2} from "../../../clientServicing/utils";
import {history} from "../../../../configureStore";
import {webHookURL} from "../V1/Steppers";
import {rateClassMappingObject} from "../../../../components/client/Proposal";
import * as AccountActions from "../../../../actions/account";
import {SU} from "../../../../model/misc";
import { Account } from "../../../../model/account";


// estimatorId is null during the invoke of hoot then need to pass run time parameter in returning function
export function useCreateAllocationPayLoad(estimatorId: null | string, externalCarrierId?: any, clientId?: number, authUser?: Account, withPublicSource: boolean = false) {
    const estimationActions = useActions(Actions);
    const estimatorActions = useActions(EstimatorActions);
    const clientActions = useActions(CActions);
    const [allocationQuestion, setAllocationQuestion] = React.useState({});
    const [clientAllocations, setClientAllocations] = React.useState({});
    const userAuth = useSelector((state: RootState) => state.auth);
    const user = authUser || userAuth.user;


    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    const carrierId = user && user.accessType === "client" ? user.demoCarrierId : clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id;
    const strategyId = user &&  user.accessType === "client" ? user && user.demoStrategy && user.demoStrategy.id : clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id
    const atlantic = useCheckAtlantic();
    let carrierIdForEstimation = atlantic ? 3 : (externalCarrierId || carrierId)
    React.useEffect(() => {
        (async () => {
            if (estimatorId) {
                const res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorId,
                    carrierId: carrierIdForEstimation
                });
                const data = {};
                if (res && res.length > 0) {
                    res.forEach((fields) => {
                        data[fields.code] = fields;
                    });
                }
                setAllocationQuestion(data)
            }
            // no need to run on demo mode
            // (user.client && user.client.id) to use on client estimator
            // clientId to use on final estimator in admin side
            if (user && user.accessType !== "client" && ((user.client && user.client.id) || clientId)) {
                // fetching client allocations assigned while invitation
                const response = await clientActions.getClientAllocations({ clientId: (clientId || user.client && user.client.id)}, withPublicSource);
                if (response && Array.isArray(response)) {
                    const data = {};
                    response.forEach((clientAllocation) => {
                        if (clientAllocation.percentage) {
                            data[clientAllocation.questionCode] = clientAllocation
                        }
                    });
                    setClientAllocations(data)
                }
                // fetching client allocations assigned while invitation
            }
        })()
    }, [estimatorId, clientId])

    // use it on places of allocationMapper[InvestmentType]
    const getAllocationQuestionForClient = (code) => {
        // if client made through new invitation and allocations exist in db
        if (clientAllocations && Object.keys(clientAllocations).length > 0) {
            return Object.keys(clientAllocations)
        }
        // for old client it will work as before
        return allocationMapper[code] || []
    }

    const getWeight = (code) => {
        if (clientAllocations[code]) {
            return clientAllocations[code].percentage;
        }
        return false;
    };
    // need to pass query to fetch estimator settings then to fetch allocations
    // one of query or (InitEstimatorId, runTimeCarrierId) needed if  estimatorId id is not define
    //  InitEstimatorId is estimator admin setting id
    return async (InvestmentType, options: {
        query?: any,
        InitEstimatorId?: any,
        runTimeCarrierId?: any
    } = {query: false, InitEstimatorId: null, runTimeCarrierId: null}) => {
        let allocationQuestionList = {...allocationQuestion};
        let {query = false, InitEstimatorId, runTimeCarrierId} = options
        carrierIdForEstimation = atlantic ? 3 : (runTimeCarrierId || carrierId)
        if (!estimatorId) {
            let res
            if (!InitEstimatorId) {
                if (!query) {
                    query = {
                        strategyId: strategyId,
                        carrierId: carrierId,
                    };
                }
                // if admin estimator setting does not exist need to fetch
                const estimatorSettings = await estimatorActions.getEstimatorDetails(query);
                res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorSettings.id,
                    carrierId: carrierIdForEstimation
                });
            } else {
                res = await estimationActions.getAllocationQuestions({
                    estimatorId: InitEstimatorId,
                    carrierId: carrierIdForEstimation
                });
            }
            isDebug() && console.log(res, " === res")
            const data = {};
            if (res && res.length > 0) {
                res.forEach((fields) => {
                    data[fields.code] = fields;
                });
            }
            allocationQuestionList = data
        }
        if (!getAllocationQuestionForClient(InvestmentType)) return [];
        const allocationweight = 100 / getAllocationQuestionForClient(InvestmentType).length
        const allocationPayload = getAllocationQuestionForClient(InvestmentType).map((code) => {
            return {
                "allocationname": code,
                "allocationrate": allocationQuestionList[code] && allocationQuestionList[code].percentage,
                "allocationweight": getWeight(code) || allocationweight,
            }
        })
        return [{
            "allocations": allocationPayload,
            "from": "1",
            "through": "M"
        }]
    }
}

export function useValidateServicingRoutes(requestType: string, userId?: string) {
    const {getServicingRequests} = useActions(clientActions);
    const [pendingRequest, setPendingRequest] = React.useState({
        editLegalName: {exist: false},
        editPersonal: {exist: false},
        editBeneficiary: {exist: false}
    })

    React.useEffect(() => {
        (async () => {
            if (userId) {
                const existingRequests = await getServicingRequests(userId);
                let obj = {...pendingRequest}
                if (existingRequests && existingRequests.length > 0) {
                    existingRequests.forEach((r) => {
                        obj = {
                            ...obj,
                            [r.requestType]: {...obj[r.requestType], exist: true, makeChangeRequest: r.aiCount > 0}
                        }
                    });
                    if (!obj[requestType].makeChangeRequest && servicingMessageV2(requestType, obj.editBeneficiary.exist, obj.editLegalName.exist, obj.editPersonal.exist)) {
                        history.push("/client/insured-details")
                    }
                    setPendingRequest(obj);
                }
            }
        })()
    }, [userId])
    return pendingRequest
}

// by default it will take current loggedIn client data
// if you pass userId it will get allocation other details from that client id
export function useRunEstimation(callingFrom: string, carrierId?: number, strategyId?: number, userId?: SU, userData: any = null) {
    let {user} = useSelector((state: RootState) => state.auth);
    const [userDetails, setUserDetails] = React.useState<any>(userData);
    if (userId && userDetails) {
        user = userDetails
    }else if(userData){
        user = userData;
    }

    const client = user && user.client;
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies[0]
    const estimatorActions = useActions(EstimatorActions);
    const accountActions = useActions(AccountActions);
    const loggedInUser = useSelector((root: RootState) => root.auth.user);
    const [estimatorData, setEstimatorData] = React.useState<any>(null);
    const fullName = user && (user.firstName + " " + user.lastName);
    let agentName: string | undefined = clientPolicy && clientPolicy.agent && clientPolicy.agent.user && `${clientPolicy.agent.user.firstName} ${clientPolicy.agent.user.lastName}`
    if (!carrierId) {
        carrierId = (clientPolicy && clientPolicy.carrierId) || (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id)
    }
    if (!strategyId) {
        strategyId = clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id
    }

    const createAllocationPayLoad = useCreateAllocationPayLoad(estimatorData && estimatorData.id, carrierId, user && user.client && user.client.id)
    React.useEffect(() => {
        (async () => {
            if (carrierId && strategyId) {
                const res = await estimatorActions.getEstimatorDetails({carrierId: carrierId, strategyId: strategyId});
                if (!!res) {
                    setEstimatorData(res);
                }
            }
        })()
    }, [carrierId, strategyId])

    React.useEffect(() => {
        (async () => {
            if (userId) {
                const account = await accountActions.getAccount(userId, 5);
                setUserDetails(account)
            }
        })()
    }, [userId])

    interface dataInterface {
        InvestmentType: string;
        // need in access type client
        [allocationFieldForm]?: any;
    }

    const runEstimation = async (payload: any = {}, data: dataInterface, functionToOverRidePayload: (payload: any) => {}) => {
        if (!carrierId) {
            alert("Please select a carrier")
            return
        }
        const carrierCode = getCarrierCode(carrierId);
        const webHookUrl: string = `${webHookURL}/${user.id}/${loggedInUser.id}?callingFrom=${callingFrom}`;
        payload["webhook"] = webHookUrl;
        if (clientPolicy && clientPolicy.id) {
            payload["webhook"] = webHookUrl + `&clientPolicyId=${clientPolicy && clientPolicy.id}`;
        }
        payload["common"]["fullname"] = fullName;
        payload["common"]["gender"] = (user.client && user.client.gender === 1) ? "Male" : "Female";
        payload["common"]["agent"]["fullname"] = agentName;
        // payload["common"]["issueage"] = issueAge || 36;
        payload["common"]["rateclass"] = rateClassMappingObject['default']; // Possible Values 'Elite_NT' | 'Preferred_NT' | 'Select_NT' | 'Standard_NT' | 'Express_Standard_NT1' | 'Express_Standard_NT2' | 'Preferred_Tobacco' | 'Standard_Tobacco' | 'Express_Standard_Tobacco';
        if (client) {
            payload["common"]["dateofbirth"] = moment(client.dob).format("MM/DD/YYYY");
        }
        if (estimatorData) {
            let commonGrowthRate = payload["common"]["growthrate"];
            // let growthRate = (commonGrowthRate * 100).toFixed(2);
            payload["stress"]["loanassumptions"]["assumptions"] = estimatorData["stressLoanRates"].split(",") || payload["stress"]["loanassumptions"]["assumptions"];
            payload["illustration"]["loanassumptions"]["assumptions"] = estimatorData["illustrationLoanRates"].split(",") || payload["illustration"]["loanassumptions"]["assumptions"];
            payload["common"]["growthrate"] = commonGrowthRate;
            payload["common"]["capitalgainstaxrate"] = estimatorData["capitalGainRate"] || payload["common"]["capitalgainstaxrate"];
            payload["common"]["managementfee"] = estimatorData["managementFee"] || payload["common"]["managementfee"];
            payload["common"]["statetaxrate"] = estimatorData["averageStateIncomeTaxRate"] || payload["common"]["statetaxrate"];
            payload["common"]["distributionloanrate"] = estimatorData["distributionLoanRate"] || payload["common"]["distributionloanrate"];
            payload["common"]["afrrate"] = estimatorData["afrRate"] || payload["common"]["afrrate"];
            payload["common"]["arrangementfee"] = estimatorData["arrangementFee"] || payload["common"]["arrangementfee"];
            payload["stress"]["loanassumptions"]["discountcashvaluelowpoint"] = estimatorData["stressTestCashValueLowPoint"] || payload["stress"]["loanassumptions"]["discountcashvaluelowpoint"];
            payload["illustration"]["loanassumptions"]["discountcashvaluelowpoint"] = estimatorData["illustrationTestCashValueLowPoint"] || payload["illustration"]["loanassumptions"]["discountcashvaluelowpoint"];
            if (createAllocationPayLoad) {
                const allocationData = (user && user.accessType === "client") ? getAllocationPayloadForAdmin(data, carrierId) : await createAllocationPayLoad(data["InvestmentType"]);
                const allocations = allocationData[0]["allocations"]
                const growthRate = calculateGrowthRate(allocations);
                if (growthRate) {
                    payload["common"]["growthrate"] = growthRate / 100;
                    payload["common"]["distributionloanrate"] = distributionLoanRate(growthRate, carrierId, estimatorData['distributionLoanRate']);
                }
                payload["illustration"]["interestrates"] = allocationData;
                payload["comparison"]["interestrates"] = allocationData;
                payload["stress"]["interestrates"] = isALGCarrier(carrierId) ? stressAllocationForALZ : stressAllocationsData;
            }
            payload["stress"]["loanassumptions"]["bankdiscountfirstyear"] = estimatorData["stressBankDiscountFirstYear"] || payload["stress"]["loanassumptions"]["bankdiscountfirstyear"];
            payload["illustration"]["loanassumptions"]["bankdiscountfirstyear"] = estimatorData["illustrationBankDiscountFirstYear"] || payload["illustration"]["loanassumptions"]["bankdiscountfirstyear"];
            payload["common"]["blendpercentage"] = estimatorData["estimatorDataBlend"] || payload["common"]["blendpercentage"];
        }
        payload["common"]["monthlypayclientextra"] = 0.05;
        payload["common"]["paymentfrequency"] = "Annual";
        payload["common"]["paymentfrequencyemployer"] = "Annual";
        payload["common"]["carrier"] = carrierCode;
        payload = functionToOverRidePayload(payload)
        return payload
    }
    return [runEstimation]
}